import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var INDRADropdownService = /** @class */ (function () {
    function INDRADropdownService() {
        this.openDropdowns = new Set();
        this.dropdownState = new BehaviorSubject(false);
        this.isOpen$ = this.dropdownState.asObservable();
    }
    INDRADropdownService.prototype.isOpen = function (id) {
        return this.openDropdowns.has(id);
    };
    INDRADropdownService.prototype.open = function (id) {
        this.openDropdowns.add(id);
        this.emitState();
    };
    INDRADropdownService.prototype.close = function (id) {
        this.openDropdowns.delete(id);
        this.emitState();
    };
    INDRADropdownService.prototype.closeAll = function () {
        this.openDropdowns.clear();
        this.emitState();
    };
    INDRADropdownService.prototype.toggle = function (id) {
        if (this.isOpen(id)) {
            this.close(id);
        }
        else {
            this.open(id);
        }
    };
    INDRADropdownService.prototype.emitState = function () {
        this.dropdownState.next(this.openDropdowns.size > 0);
    };
    INDRADropdownService.ngInjectableDef = i0.defineInjectable({ factory: function INDRADropdownService_Factory() { return new INDRADropdownService(); }, token: INDRADropdownService, providedIn: "root" });
    return INDRADropdownService;
}());
export { INDRADropdownService };
